import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { isEmpty, isEqual } from 'lodash'
import { useLoginMutation } from 'config/api/waV1_user'
import { tokenHandler, userProfileSetter } from 'config/slice/global'
import { toggleNoti, toggleError } from 'config/slice/message'
import { getCookie, setCookie } from 'utils/cookies'
import useCheckToken from 'utils/useCheckToken'
import {
    COOKIE_TOKEN,
    HTTP_401,
    HTTP_422,
    STORAGE_USER_PATHNAME,
    STORAGE_USER_PROFILE
} from 'config/const/global'
import {
    TYPE_ACCOUNT,
    TYPE_PASSWORD
} from 'config/const/type'
import {
    KEY_ERROR_ACCOUNT_NOT_FILL,
    KEY_ERROR_ACCOUNT_PASSWORD_ERROR,
    KEY_ERROR_PASSWORD_NOT_FILL,
    KEY_PHD_ACCOUNT,
    KEY_PHD_PASSWORD,
    KEY_TEXT_BTN_LOGIN,
    KEY_TEXT_BTN_REG,
    KEY_TEXT_LINK_FORGET_PWD,
    KEY_TEXT_LOGIN_SUCCESSFULLY,
    KEY_TEXT_MODAL_TITLE,
    MODULE_LOGIN
} from 'config/const/locale'
import { setTabById } from 'config/slice/sidebar'



export default function Login() {

    const [iptValue, setIptValue] = useState({
        [TYPE_ACCOUNT]: '',
        [TYPE_PASSWORD]: ''
    }) // inputs' value
    const [loginFn] = useLoginMutation() // login API from RTKQ
    const dispatch = useDispatch() // redux method manipulating the state
    const { t } = useTranslation(MODULE_LOGIN) // i18n hook, i18n.changeLanguage('en') method to change language
    const navigate = useNavigate() // navigator


    /**
     * handle inputs relating to login
     * @param {String} type input's type and key
     */
    const iptHandler = (type) => (e) => setIptValue(prev => ({ ...prev, [type]: e.target.value }))

    // login btn handler, data checking and msg noticing
    const loginHandler = () => {

        if (isEmpty(iptValue[TYPE_ACCOUNT])) { // check account input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_ACCOUNT_NOT_FILL)
            }))
            return
        }
        if (isEmpty(iptValue[TYPE_PASSWORD])) { // check password input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_PASSWORD_NOT_FILL)
            }))
            return
        }

        loginFn(iptValue).then( // save login token, set cookie and send noti if succeed, otherwise set error msg and return
            result => {

                if (result?.data?.data?.token) {
                    dispatch(tokenHandler({
                        switch: true,
                        newToken: result.data.data.token
                    }))
                    dispatch(userProfileSetter(result.data.data.user))
                    setCookie(STORAGE_USER_PROFILE, result.data.data.user)
                    setCookie(COOKIE_TOKEN, result.data.data.token)
                    dispatch(toggleNoti({
                        indicator: true,
                        msg: t(KEY_TEXT_LOGIN_SUCCESSFULLY)
                    }))
                    dispatch(setTabById(3))
                    navigate(getCookie(STORAGE_USER_PATHNAME))
                    return
                }

                if (result?.error && (isEqual(result?.error?.status, HTTP_422) || isEqual(result?.error?.status, HTTP_401))) {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_ACCOUNT_PASSWORD_ERROR)
                    }))
                }

                return dispatch(toggleError({
                    indicator: true,
                    msg: result?.error?.data?.message?.message || t(KEY_ERROR_ACCOUNT_PASSWORD_ERROR)
                }))

            }
        )

    }

    // check login token
    useCheckToken()

    return (
        <div className='wa-fullscreen wa-bg-login'>

            <div className="login-box position-fixed start-50 top-50 translate-middle">
                <div className="card wa-light-blue wa-rounded-2rem overflow-hidden">
                    <div className="card-header">
                        <div className="link-dark text-center link-offset-2 link-opacity-100 link-opacity-50-hover text-white wa-light-blue">
                            <h1 className='fs-3 p-3'>
                                {t(KEY_TEXT_MODAL_TITLE)}
                            </h1>
                        </div>
                    </div>
                    <div className="card-body login-card-body">
                        <form>
                            <div className="input-group mb-1">
                                <div className="form-floating col-11 p-0 wa-h-5rem">
                                    <input id="loginEmail" type="email" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_ACCOUNT)} />
                                    <label htmlFor="loginEmail" className='fs-4 ps-4'>{t(KEY_PHD_ACCOUNT)}</label>
                                </div>
                                <div className="input-group-text col-1 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-envelope"></span> */}
                                </div>
                            </div>
                            <div className="input-group my-5">
                                <div className="form-floating col-11 p-0 wa-h-5rem">
                                    <input id="loginPassword" type="password" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_PASSWORD)} />
                                    <label htmlFor="loginPassword" className='fs-4 ps-4'>{t(KEY_PHD_PASSWORD)}</label>
                                </div>
                                <div className="input-group-text col-1 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-lock-fill"></span> */}
                                </div>
                            </div>
                            {/* <!--begin::Row--> */}
                            <div className="row mb-4">
                                {/* <div className="col-8 d-inline-flex align-items-center">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                            Remember Me
                                        </label>
                                    </div>
                                </div> */}
                                {/* <!-- /.col --> */}
                                <div className="col-12">
                                    <div className="d-grid gap-2" onClick={loginHandler}>
                                        <a className="btn wa-light-blue text-white p-4 fs-4 rounded rounded-pill">{t(KEY_TEXT_BTN_LOGIN)}</a>
                                    </div>
                                </div>
                                {/* <!-- /.col --> */}
                            </div>
                            {/* <!--end::Row--> */}
                        </form>
                        {/* <!-- /.social-auth-links --> */}
                        <p className="mb-1 text-center">
                            <Link to={'/forgetPwd'} className='text-decoration-underline text-secondary'>{t(KEY_TEXT_LINK_FORGET_PWD)}</Link>
                            <br />
                            <Link to={'/reg'} className='text-decoration-underline text-secondary'>{t(KEY_TEXT_BTN_REG)}</Link>
                        </p>
                    </div>
                    {/* <!-- /.login-card-body --> */}
                </div>
            </div>
        </div>
    )
}
